<template>
  <div style="height: 100%">

    <div v-show="!isMobile"
         style="height: 100%">
      <CustomCpn v-show="false"
                 ref="customCpn"></CustomCpn>
      <el-container class="inner-container">
        <el-aside class="inner-aside"
                  v-show="showLeftPanel">
          <AsideMenue @on-clearHomeInput="clearHomeInput"
                      ref="asideMenu"></AsideMenue>
        </el-aside>
        <div style="position: absolute;height: 100%; left: 260px;display: flex; align-items: center;cursor: pointer;z-index: 99"
             @click="showLeftPanelMethod(false)"
             v-if="showLeftPanel">
          <i class="el-icon-arrow-left"
             style="font-size: 30px;font-weight: bold;color: #565656"></i>
        </div>
        <div style="position: absolute;height: 100%; left: 0px;display: flex; align-items: center;cursor: pointer;z-index: 99"
             @click="showLeftPanelMethod(true)"
             v-if="!showLeftPanel">
          <i class="el-icon-arrow-right"
             style="font-size: 30px;font-weight: bold;color: #565656"></i>
        </div>
        <el-container class="inner-container2">
          <el-header style="height: 50px">
            <TopHeader></TopHeader>
          </el-header>
          <template>
            <div v-if="noticeMsgArr"
                 class="headMsgBox"
                 v-html="noticeMsgArr"></div>
          </template>
          <div class="content"
               v-show="!showSet && !showInvite">
            <div id="chat">
            </div>
          </div>
          <div v-show="showInvite"
               style="height: 100%">
            <Invite @openHelpDialog="openHelpDialog"></Invite>
          </div>
          <div v-show="showSet"
               style="height: 100%">
            <Setup></Setup>
          </div>
          <div v-show="isNullChatId"
               style="height: calc(100% - 60px); background: #f4f5fa">
            <div class="home-page"
                 style="height: 100%; overflow-y: scroll">
              <div class="title-area">
                <div class="title">你好, 我是镜界AI</div>
                <div class="sub-title">你专属的市场洞察与消费者研究专家！快来向我提问吧！下一个抢占市场先机的就是你！</div>
              </div>
              <div class="tips-area">
                <img src="../assets/img/notice.png"
                     style="width: 14px;height: 14px" />
                <span>试试点击下方的问题模板，替换关键词直接提问！</span>
              </div>
              <div class="default-questions-area"
                   style="width: 800px; margin-bottom: 0;">
                <div class="bubble default-questions-card"
                     :class="{isnullchatId: isNullChatId}"
                     style="margin-bottom: 0; background-color: white; padding: 0 16px;"
                     v-for="item in defaultQuestions"
                     :key="item.title">
                  <div class="questions-header">
                    {{item.title}}
                  </div>
                  <div class="question-item"
                       @click="questionClick(ele)"
                       v-for="ele in item.question"
                       :key="ele.content">
                    <img src="../assets/img/circle.png"
                         style="width:8px;height:8px;margin-right: 5px;margin-top: 7px"
                         alt="">{{ele.content}}
                  </div>
                </div>

              </div>
              <div class="input-area home-input-area">
                <inputCpn type="home"
                          ref="homeInputCpn"
                          :loginInfo="loginInfo"
                          @inputCallback="homeInputCallback"></inputCpn>

                <!-- <el-input placeholder="使用上方模板向我提问"
                        type="textarea"
                        :autosize="{ minRows: 2, maxRows: 100}"
                        @keyup.native.enter="handleHomeEnter"
                        v-model="homeInputValue"></el-input>
              <i class="el-icon-position"
                 style="position: absolute; bottom: 5px;right: 15px; cursor: pointer;color: #2F4EFF"
                 @click="handleHomeEnter"></i> -->
              </div>
            </div>
          </div>

          <div id="preview-window">
            <el-tooltip class="item"
                        effect="dark"
                        content="将图片下载到本地或利用浏览器缩放查看高清图片"
                        placement="bottom">
              <img src=""
                   alt="">
            </el-tooltip>
          </div>

          <div class="bottom-footer"
               style="background: #f4f5fa">
            <Footer></Footer>
          </div>
        </el-container>
        <div style="position: absolute;height: calc(100% - 50px);top: 50px; right: 440px;display: flex; align-items: center;cursor: pointer;z-index: 99"
             @click="showRightPanelMethod(false)"
             v-if="$store.state.user.chatId != 'setup'&&$store.state.user.chatId != 'invite' && showRightAside">
          <i class="el-icon-arrow-right"
             style="font-size: 30px;font-weight: bold;color: #565656"></i>
        </div>
        <div style="position: absolute;height: calc(100% - 50px);top: 50px; right: 10px;display: flex; align-items: center;cursor: pointer;z-index: 99"
             @click="showRightPanelMethod(true)"
             v-if="$store.state.user.chatId != 'setup'&&$store.state.user.chatId != 'invite' && !showRightAside">
          <i class="el-icon-arrow-left"
             style="font-size: 30px;font-weight: bold;color: #565656"></i>
        </div>
        <div class="inner-aside right-aside"
             style="width: 400px !important"
             v-if="$store.state.user.chatId != 'setup'&&$store.state.user.chatId != 'invite' && showRightAside">
          <div v-for="item in showSideData"
               class="right-aside-item"
               :class="item.class_list_affix"
               :key="item.class_list_affix">
            <div class="aside-item-header"
                 v-if="item.link_type != '1'">
              <span>{{item.message_title}}</span>
            </div>
            <div class="aside-item-header"
                 v-else>
              <a :href="item.message_link"><span>{{item.message_title}}</span> <i class="iconfont icon-tiaozhuan"
                   style="margin-left: 5px"></i></a>

            </div>
            <div class="aside-item-img itemPreview"
                 v-html="item.message_image"></div>
            <div class="aside-item-content">
              <div class="aside-item-text">
                <ExpandCpn :htmlContent="item.message_content" />
              </div>
              <div v-if="item.link_type == '1'"
                   v-html="registrationText"
                   style="margin-bottom: 10px">
              </div>
            </div>
          </div>
        </div>
        <PayDialog :getOrderListPromise="getAllOrderTypeList"
                   :getPayDetail="getPayDetail"
                   :queryPay="queryPay"
                   :visible="showPayDialog"
                   :orderId="orderId"
                   :yearOrderId="yearOrderId"
                   @payDialogClose="payDialogClose"
                   @on-paySuccess="paySuccess">
        </PayDialog>
        <jumpLinkDialog ref="jumpLinkDialog"
                        :link="jumpLink" />
        <div id="download-pop"
             class="el-tooltip__popper is-dark"
             style="display: none;"
             x-placement="bottom">
          <span>{{downloadText}}</span>
          <div x-arrow=""
               class="popper__arrow"
               style="left: 34px;"></div>
        </div>
        <div id="share-pop"
             class="el-tooltip__popper is-dark"
             style="display: none;"
             x-placement="bottom">
          <span>分享对话链接</span>
          <div x-arrow=""
               class="popper__arrow"
               style="left: 34px;"></div>
        </div>
        <div id="question-pop"
             class="el-tooltip__popper is-dark"
             style="display: none;"
             x-placement="bottom">
          <span id="question-pop-text"></span>
          <div x-arrow=""
               class="popper__arrow"
               style="left: 0px; top: 1px;"></div>
        </div>
        <div id="question-help-pop"
             class="el-tooltip__popper is-dark"
             style="display: none;"
             x-placement="top">
          <div style="margin-bottom: 10px">不知道怎么准确描述您的问题？</div>
          <div>可以<el-link @click="openHelpDialog"
                     style="color: white;text-decoration: underline;
    margin: 0 5px;
    vertical-align: text-top;">联系客服</el-link>获取专业帮助</div>
        </div>
        <HomeDialog :visible="homeDialogVisible" />
        <KfDialog :visible="kfDialogVisible"
                  @close="kfDialogVisible = false"></KfDialog>
        <JdUserKF :visible="jdDialogVisible"
                  @close="jdDialogVisible = false"></JdUserKF>
        <el-dialog :visible.sync="kfPicShow"
                   width="250px"
                   :before-close="handleKfClose"
                   custom-class="login-dialog">
          <div class="login-area">
            <img v-if="$store.state.user.kfImgUrl"
                 :src="$store.state.user.kfImgUrl"
                 style="width: 180px; height: 180px;"
                 alt="">
            <img v-else
                 src="../assets/kf.png"
                 style="width: 180px; height: 180px;"
                 alt="">
            <div class="login-sub-desc">扫码即刻获取专业帮助</div>
          </div>
        </el-dialog>
        <div v-show="showTitlePop"
             class="title-popup"
             ref="TitlePop">
          <div class="title-explain"><i class="el-icon-warning"></i>填写说明</div>
          <div style="color: #e2584d;"
               class="desc-div">不要使用<span class="content">空格、顿号、逗号、斜杠</span>等符号连接多个词</div>
          <div class="desc-div"
               style="color: #e2584d;"><span class="content">词与and or not之间一定要留有空格</span>，否则无效</div>
          <div class="desc-div"
               style="color: #333333CC; font-size: 12px;">and：商品标题关键词中同时包含</div>
          <div class="desc-div"
               style="color: #333333CC; font-size: 12px;">or：商品标题关键词中包含其中一个</div>
          <div class="desc-div"
               style="color: #333333CC; font-size: 12px;">not：商品标题关键词中不包含</div>
          <div class="desc-div">正确填写示例:</div>
          <div class="desc-div">查茶叶和茶饮的整体市场: <span style="font-style: italic;">茶叶 or 茶饮</span></div>
          <div class="desc-div">查儿童或婴童手表: <span style="font-style: italic;">(婴童 or 儿童) and 手表</span></div>
          <div class="pop-table">
            <table>
              <tr>
                <th style="width: 100px">错误填写示例</th>
                <th>错误原因</th>
                <th>正确填写</th>
              </tr>
              <tr>
                <td>多肽or 肽</td>
                <td class="error">or与词"多肽"之间没有空格！</td>
                <td>多肽 or 肽</td>
              </tr>
              <tr>
                <td>保冷/保温杯</td>
                <td class="error">使用"/"连接多个词无效！</td>
                <td>(保冷 or 保温) and 杯</td>
              </tr>
              <tr>
                <td>商务背包，户外背包</td>
                <td class="error">使用","连接多个词无效！</td>
                <td>(商务 or 户外) and 背包</td>
              </tr>
            </table>
          </div>
        </div>
        <div v-show="showBrandPop"
             class="title-popup"
             ref="BrandPop">
          <div class="title-explain"><i class="el-icon-warning"></i>填写说明</div>
          <div class="desc-div">如需圈定品牌范围,建议一次只查询一个品牌,分析更精准</div>
          <p class="desc-div"
             style="color: #e2584d">不要使用<span class="content">空格、顿号、逗号、斜杠</span>等符号连接多个品牌</p>
          <p class="desc-div"
             style="color: #e2584d">查询多个品牌的合计市场表现务必用<span class="content">or</span>连接</p>
          <p class="desc-div"
             style="color: #e2584d"><span class="content">品牌词与or之间一定要留有空格</span>，否则无效</p>
          <div class="pop-table">
            <table>
              <tr>
                <th style="width: 100px">错误填写示例</th>
                <th>错误原因</th>
                <th>正确填写</th>
              </tr>
              <tr>
                <td>华为、小米、苹果</td>
                <td class="error">使用"、"连接多个品牌无效!</td>
                <td>华为 or 小米 or 苹果</td>
              </tr>
              <tr>
                <td>可复美or薇诺娜</td>
                <td class="error">品牌词与or之间没有空格,无效!</td>
                <td>可复美 or 薇诺娜</td>
              </tr>
              <tr>
                <td>美的,格力,追觅</td>
                <td class="error">使用","连接多个词无效！</td>
                <td>美的 or 格力 or 追觅</td>
              </tr>
            </table>
          </div>
        </div>
      </el-container>
    </div>
    <div v-if="isMobile"
         class="AI-mobile-content">
      <img src="../assets/mobile.png"
           class="AI-image">
    </div>
  </div>
</template>
<script>
import '@/libs/js/jquery.ztree.core'
import '@/libs/js/jquery.ztree.excheck.js'
import '@/libs/js/jquery.ztree.exedit.js'
import '@/libs/css/treeSelectStyle.css'
import { Bubbles } from './Bubbles.js'
import '@/style/setup.css'
import '@/style/says.css'
import '@/style/reply.css'
import '@/style/typing.css'
import '@/style/input.css'
import '@/components/robot-css/robot-v2.less'
import TopHeader from '@/components/topHeader.vue'
import AsideMenue from './AsideMenue.vue'
import Setup from '@/views/Setup.vue'
import {
  postNewChat,
  postAskChat,
  postHistory,
  postAnswer,
  postDefaultQuestion,
  postPay,
  getNoticeInfo,
  postShareDoc,
} from '@/api/public'
import CustomCpn from './CustomCpn.vue'
import { PayDialog } from 'common'
import { getAllOrderTypeList, getPayDetail, queryPay } from '@/api/pay.js'
import jumpLinkDialog from './jumpLinkDialog.vue'
import {
  jumpToBlank,
  jumpToSelf,
  getCurrentTimeString,
  getBrowserInfo,
  escapeHtml,
} from '@/utils'
import Footer from './footer.vue'
import { overseaPlatMap } from './cat-plat/platOptions'
import { getUserInfo } from '@/api/user'
import { downloadFileByLink } from '@/utils/download.js'
import { getObjFromUrl, getTagF, extractShareId } from '@/utils'
import HomeDialog from './HomeDialog.vue'
import KfDialog from './KfDialog.vue'
import JdUserKF from './JdUserKF.vue'
import {
  generateCatFilterStr,
  insertContent,
  removeCatSelector,
  isFetchDone,
} from './cat-plat/catString.js'
import MarkdownIt from 'markdown-it'
import Vue from 'vue'
import ExpandCpn from './ExpandCpn.vue'
import FilterPanel from './filterPanelCpn/FilterPanel.vue'
import Invite from '../views/Invite.vue'
import InputCpn from './inputCpn/InputCpn.vue'
import { DateTime } from 'luxon'

export default {
  components: {
    TopHeader,
    AsideMenue,
    CustomCpn,
    Setup,
    PayDialog,
    jumpLinkDialog,
    Footer,
    HomeDialog,
    KfDialog,
    ExpandCpn,
    Invite,
    InputCpn,
    JdUserKF,
  },
  data() {
    this.catTreeObj = {}
    return {
      noticeMsgArr: '',
      showLeftPanel: true,
      showRightAside: false,
      chatWindow: null,
      convo: {
        robot: {
          says: [
            `Hi!我是魔镜·镜界AI，你专属的市场洞察与消费者研究专家！
            我的使用文档：<a href="https://qmctsz2s8t.feishu.cn/docx/NdaOdC8MPo4gi8xk76ZcXD3Unre" class="link el-link el-link--primary" style="vertical-align: top;" target="_blank">【魔镜·镜界 Al】产品使用文档 </a>
            试试点击上方的问题模板，替换关键词直接使用！
            我可以从【桌面调研】【市场数据】【消费者评论】【社媒分析】四个方面为你提供全方位的市场调研结果~
            我还可以帮你调研【海外市场】，海外数据现已支持美国亚马逊！
            快来向我提问吧！下一个抢占市场先先机的就是你！`,
          ],
        },
      },
      isLock: false,
      defaultQuestions: [],
      bubbleIds: [], // bubble id集合
      showQuestions: false,
      interval: '',
      zNodes: [],
      paramTimeout: '',
      showSet: false,
      writingList: [],
      getAllOrderTypeList: getAllOrderTypeList,
      getPayDetail: getPayDetail,
      queryPay: queryPay,
      showPayDialog: false,
      newAIUser: false,
      orderId: '',
      yearOrderId: '',
      isNullChatId: false,
      homeInputValue: '',
      jumpLink: '',
      isMobile: this.$store.state.user.isMobile,
      downloading: false,
      downloadText: '将对话内容下载为文档',
      addDownloadTimeoutId: '',
      homeDialogVisible: false,
      kfPicShow: false,
      fifteenTimeout: '',
      listItemClass: '',
      kfDialogVisible: false,
      jdDialogVisible: false,
      sideData: null,
      showSideData: [],
      questionId: '',
      catTime: ['2024-09', '2024-09'],
      user_click_left_side: false, // 用户是否手动点击了展开左边栏
      registrationText:
        '<div class="registration-text">此内容由AI生成，仅供参考</div>',
      showTitlePop: false,
      showBrandPop: false,
      filterPanelVm: null,
      showInvite: false,
      isShare: false,
      feishuLoading: false, // 飞书加载中
    }
  },
  async created() {
    this.getNoticeInfoMethod()
    // getTagF()
    this.initHomeQuestion()
    await this.initCat()

    let self = this
    //*********监听跳转
    document.addEventListener('DOMContentLoaded', function () {
      const links = document.querySelectorAll('a')
      links.forEach((link) => {
        link.addEventListener('click', function (event) {
          event.preventDefault() // 阻止默认的链接跳转行为

          self.jumpBlankLink(this.href)
        })
      })
    })
    // 监听动态添加的链接
    const observer = new MutationObserver((mutations) => {
      $('.ai-side')
        .off('click')
        .on('click', function () {
          const matchedClass = $(this).attr('class_id')
          const questionId = $(this).attr('question_id')
          if (self.sideData) {
            self.showSideData = self.sideData
              .filter((item) => item.question_id == questionId)
              .map((item) => {
                const md = new MarkdownIt({
                  html: true, // 允许解析 HTML
                })
                let htmlOutput = md.render(item.message_content)

                item.message_content = htmlOutput
                return item
              })
          }
          if (matchedClass) {
            self.listItemClass = matchedClass
            self.showRightAsideMethods(true)
          }
        })
      $('.answer-analyse-title')
        .off('click')
        .on('click', function () {
          this.classList.toggle('fold-bubble')
        })
      $('.answer-fetch-title')
        .off('click')
        .on('click', function () {
          // 获取父元素的 question_id 属性
          const questionId = $(this).attr('question_id')
          if (questionId) {
            self.showRightAsideMethods(true, questionId)
          }
        })

      $('.itemPreview img')
        .off('click')
        .click(function () {
          var img = $(this).attr('src')
          $('#preview-window img').attr('src', img)
          $('#preview-window').fadeIn()
        })
      $('#preview-window').click(function () {
        $(this).fadeOut()
      })
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.tagName === 'A') {
            node.addEventListener('click', function (event) {
              event.preventDefault() // 阻止默认的链接跳转行为
              self.jumpBlankLink(this.href)
            })
          } else if (node.nodeType === Node.ELEMENT_NODE) {
            // 递归检查子节点
            addClickListenerToLinks(node)
          }
        })
      })
    })

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    })
    // 递归函数，用于为节点中的所有<a>标签添加点击事件监听器
    function addClickListenerToLinks(node) {
      const childLinks = node.querySelectorAll('a')
      childLinks.forEach((link) => {
        link.addEventListener('click', function (event) {
          event.preventDefault() // 阻止默认的链接跳转行为

          self.jumpBlankLink(this.href)
        })
      })
    }
    //*******end监听跳转 */
  },
  computed: {
    chatStatus() {
      return this.$store.state.user.chatStatus.status
    },
    loginInfo() {
      return this.$store.state.user.loginInfo
    },
    leftSideSticky() {
      return this.$refs.asideMenue
        ? this.$refs.asideMenue.leftSideSticky
        : false
    },
  },
  mounted() {
    getTagF()
    this.$eventBus.$on('jumpToInvite', () => {
      // 获取当前页面的完整URL
      const currentUrl = window.location.href

      // 检查URL中是否已经包含查询参数
      const hasQuery = currentUrl.includes('?')

      // 根据是否包含查询参数来拼接新的URL
      const newUrl = hasQuery
        ? `${currentUrl}&page=invite`
        : `${currentUrl}?page=invite`
      jumpToBlank(newUrl)
    })
    this.$eventBus.$on('showHomeDialog', () => {
      this.homeDialogVisible = true
    })
    this.$eventBus.$on('showPayDialog', (source) => {
      const browserFinger = localStorage.getItem('browserFinger')
      const browserInfo = getBrowserInfo()
      let property = {
        $device_id: mixpanel.get_property('$device_id'),
        $initial_referring_domain: mixpanel.get_property(
          '$initial_referring_domain'
        ),
        $initial_referrer: mixpanel.get_property('$initial_referrer'),
        browser_id: browserFinger ? browserFinger : '',
        ...browserInfo,
      }
      const params = {
        event_time: getCurrentTimeString(),
        source: source,
      }
      this.updateUserInfo().then(() => {
        mixpanel.track('Pay Notice Event', params)
      })
      this.showPayDialog = true
      // postPay({
      //   username: this.$store.state.user.loginInfo.username,
      //   property,
      // }).then((res) => {
      //   if (res.status == 'ok') {
      //     const result = res.result
      //     this.orderId = result.order_id
      //     this.yearOrderId = result.year_order_id
      //     this.showPayDialog = false
      //     this.$nextTick(() => {
      //       const params = {
      //         event_time: getCurrentTimeString(),
      //         source: source,
      //       }
      //       this.updateUserInfo().then(() => {
      //         mixpanel.track('Pay Notice Event', params)
      //       })
      //       this.showPayDialog = true
      //     })
      //   } else {
      //     this.showPayDialog = false
      //   }
      // })
    })
    this.$eventBus.$on('showKfDialog', this.openHelpDialog)

    const query = getObjFromUrl(window.location.hash)
    const share_id = extractShareId(query)
    if (share_id) {
      this.$store.dispatch('user/changeChatId', share_id)
      this.isShare = true
    }
  },
  methods: {
    getNoticeInfoMethod() {
      getNoticeInfo()
        .then((res) => {
          if (res && res.result) {
            if (res.result.msg) {
              this.noticeMsgArr = res.result.msg
            } else {
              this.noticeMsgArr = ''
            }
          } else {
            this.noticeMsgArr = ''
          }
        })
        .catch((e) => {
          let msg = e.backMsg
          if (e.data && e.data.error_msg) {
            if (_.isObject(e.data.error_msg)) {
              msg = e.data.error_msg.msg
            } else {
              msg = e.data.error_msg
            }
          }
          this.noticeMsgArr = msg
        })
    },
    stopWrapVisible(visible) {
      this.inputCpnVm.$refs.dynamicInputCpn.showStop = visible
    },
    async homeInputCallback(value) {
      this.homeInputValue = value
      if (!this.loginInfo) {
        if (window.mixpanel) {
          mixpanel.track('Not Login User Question', {
            question: this.homeInputValue,
          })
        }
        this.$eventBus.$emit('showLoginDialog')
      } else {
        await this.judgeUserAiPay()
        if (this.loginInfo.wecom_pop_up) {
          this.kfDialogVisible = true
          if (window.mixpanel) {
            mixpanel.track('Free Count Notice')
          }
          return
        }
        postNewChat().then((res) => {
          if (res.status == 'ok') {
            const result = res.result
            this.$eventBus.$emit('homeNewChat', result)
          }
        })
        let query = getObjFromUrl(window.location.hash)
        if (query && query.f && query.cb) {
          window.zhad.push({ eventtype: 'js_ask' })
        }
      }
    },
    removeCatSelector() {
      $('.confirm-params-area').hide()
      if (this.filterPanelVm) {
        this.filterPanelVm.$destroy()
        this.filterPanelVm = null
      }
    },
    addCatTreeSelector(param) {
      const targetElement = document.querySelector('.filter-panel-area')
      this.filterPanelVm = new Vue({
        render: (h) =>
          h(FilterPanel, {
            props: {
              params: param,
              catTime: this.catTime,
            },
            on: {
              'mounted-event': () => {},
              change: (dateTime) => {
                this.catTime[0] = dateTime[0]
                this.catTime[1] = dateTime[1]
              },
              'confirm-event': (params) => {
                this.confirmHandler(params)
              },
              'contact-event': () => {
                this.openHelpDialog()
              },
              blurTitle: () => {
                this.showTitlePop = false
              },
              blurBrand: () => {
                this.showBrandPop = false
              },
              focusTitle: (clientRect) => {
                this.showTitlePop = true
                this.$nextTick(() => {
                  const element = this.$refs['TitlePop']
                  element.style.top =
                    clientRect.inputRect.top + window.scrollY - 100 + 'px'
                  element.style.left =
                    clientRect.inputRect.left + window.scrollX - 290 + 'px'
                })
              },
              focusBrand: (clientRect) => {
                this.showBrandPop = true
                this.$nextTick(() => {
                  const element = this.$refs['BrandPop']
                  element.style.top =
                    clientRect.inputRect.top + window.scrollY - 100 + 'px'
                  element.style.left =
                    clientRect.inputRect.left + window.scrollX - 290 + 'px'
                })
              },
            },
          }),
      }).$mount(targetElement)
    },
    sideLinkText(type) {
      switch (type) {
        case '1':
          return '订阅可查看完整内容'
        case '2':
          return '阅读全文'
        case '3':
          return '阅读全文'
      }
    },
    jumpToItemLink(item) {
      if (item.link_type == '1') {
        this.jumpBlankLink(item.message_link)
      } else {
        jumpToBlank(item.message_link)
      }
    },
    showLeftPanelMethod(type) {
      this.user_click_left_side = type
      if (!type) {
        this.showLeftPanel = false
      } else {
        this.showLeftPanel = true
        if (this.showRightAside) {
          this.showRightAside = false
        }
      }
    },
    showRightPanelMethod(type) {
      if (!type) {
        this.showRightAside = false
      } else {
        this.showRightAside = true
        if (this.showLeftAside && !this.leftSideSticky) {
          this.showLeftAside = false
        }
      }
    },
    showRightAsideMethods(type, question_id) {
      if (type) {
        if (question_id) {
          this.showSideData = this.sideData
            .filter((item) => item.question_id == question_id)
            .map((item) => {
              const md = new MarkdownIt({
                html: true, // 允许解析 HTML
              })

              let htmlOutput = md.render(item.message_content)

              item.message_content = htmlOutput
              return item
            })
        } else if (this.questionId) {
          this.showSideData = this.sideData
            .filter((item) => item.question_id == this.questionId)
            .map((item) => {
              const md = new MarkdownIt({
                html: true, // 允许解析 HTML
              })

              let htmlOutput = md.render(item.message_content)

              item.message_content = htmlOutput
              return item
            })
        }
        this.showRightAside = true
        let leftSideSticky = localStorage.getItem('leftSideSticky')
        switch (leftSideSticky) {
          case 'true':
            leftSideSticky = true
            break
          case 'false':
            leftSideSticky = false
            break
        }
        if (!leftSideSticky) {
          this.showLeftPanel = false
        }
        // 查找类名为 "right-aside" 的 div
        const rightAside = document.querySelector('.right-aside')
        this.$nextTick(() => {
          if (rightAside) {
            // 在 "right-aside" 的范围内查找类名为 "list-NVCN26" 的 div
            function selectElementByClassName(className) {
              // 如果类名以数字开头，需要进行转义
              if (/^\d/.test(className)) {
                // 对首数字进行转义
                className = className.replace(/^\d/, (digit) => `\\3${digit} `)
              }
              return document.querySelector(`.${className}`)
            }
            if (this.listItemClass) {
              const targetDiv = selectElementByClassName(this.listItemClass)

              if (targetDiv) {
                // 将目标元素聚焦到视图中
                targetDiv.scrollIntoView({
                  behavior: 'smooth',
                  block: 'start',
                })
                // 可选：为目标元素添加聚焦样式
              }
            }

            const bubbleWrap = document.querySelector('.bot-bubble-wrap')
            const inputWrap = document.querySelector('.input-wrap')
            const stopWrap = document.querySelector('.stop-wrap-div')

            if (bubbleWrap) {
              bubbleWrap.style.setProperty(
                'padding-right',
                '400px',
                'important'
              )
            }
            if (inputWrap) {
              inputWrap.style.setProperty('padding-right', '400px', 'important')
            }
            if (stopWrap) {
              stopWrap.style.setProperty('padding-right', '400px', 'important')
            }
          }
        })
      }
    },
    handleKfClose() {
      this.kfPicShow = false
    },
    openHelpDialog() {
      this.kfPicShow = true
    },
    async initCat() {
      return new Promise((resolve, reject) => {
        try {
          const s = document.createElement('script')
          s.type = 'text/javascript'
          s.src =
            'https://chance.mktindex.com/static/chance/json/wx_bigcats.js' +
            '?ts=2023-04'
          document.body.appendChild(s)
          s.onload = function () {
            let datas = window.cache_cat
            resolve(datas)
          }
        } catch (err) {
          reject(err)
        }
      })
    },
    initChatBubble() {
      let self = this
      const metaImg = require('../assets/img/meta_check.png')
      this.removeDownloadBtn()
      let isDefault = this.containsDefault(this.$store.state.user.chatId)
      this.chatWindow = new Bubbles(
        document.getElementById('chat'),
        'chatWindow',
        {
          inputCallbackFn: function (o) {
            self.inputCallbackFn(o)
          },
          copyCallbackFn: function (o) {
            self.copyCallbackFn(o)
          },
          defaultQuestionCallbackFn: function (o) {
            self.defaultQuestionCallbackFn(o)
          },
          replyCallbackFn: function (o, c) {
            self.replyCallbackFn(o, c)
          },
          stopCallbackFn: function () {
            self.stopCallbackFn()
          },
          suggestCallbackFn: function (text) {
            self.suggestCallbackFn(text)
          },
          isDefault: isDefault,
          isShare: this.isShare,
        }
      )
      const targetElement = document.querySelector('.input-send-wrap')
      this.inputCpnVm = new Vue({
        render: (h) =>
          h(InputCpn, {
            props: {
              isLock: this.isLock,
              homeDeepType: this.homeInputValue
                ? this.$refs['homeInputCpn'].deepthinkType
                : '-1',
              isDefault: isDefault,
              loginInfo: this.loginInfo,
            },
            // 添加 ref
            ref: 'dynamicInputCpn',
            on: {
              inputCallback: (value, deep_thinking) => {
                if (!this.isShare) {
                  this.chatWindow.addBubble(
                    '<span class="bubble-button bubble-pick">' +
                      escapeHtml(value) +
                      '</span>',
                    function () {},
                    'reply reply-freeform'
                  )
                  this.inputCallbackFn({
                    input: value,
                    convo: {},
                    standingAnswer: 'robot',
                    deep_thinking: deep_thinking ? '1' : '',
                  })
                } else {
                  this.homeInputCallback(value)
                }
              },
              stopCallbackFn: this.stopCallbackFn,
              'contact-event': () => {
                this.openHelpDialog()
              },
            },
          }),
      }).$mount(targetElement)

      document
        .getElementsByClassName('bot-bubble-wrap')[0]
        .addEventListener('click', (event) => {
          // event.target是被点击的元素
          if (event.target.classList.contains('help-link')) {
            // 执行点击事件的逻辑
            this.openHelpDialog()
          }
        })
      this.addInputHelpPoP()

      this.initDefaultQuestion().then(() => {
        let getHistoryMethod
        if (isDefault) {
          getHistoryMethod = postDefaultQuestion
        } else {
          getHistoryMethod = postHistory
        }
        getHistoryMethod({
          conv_id: this.chatId,
        }).then((res) => {
          if (res.status == 'ok') {
            const result = res.result
            const data = JSON.parse(result.data)
            if (result.side_data) {
              const sideData = JSON.parse(result.side_data)
              this.sideData = sideData
            }
            if (data.length == 0) {
              if (this.homeInputValue) {
                this.chatWindow.addBubble(
                  '<span class="bubble-button bubble-pick">' +
                    escapeHtml(this.homeInputValue) +
                    '</span>',
                  function () {},
                  'reply reply-freeform'
                )
                this.inputCallbackFn({
                  input: this.homeInputValue,
                  deep_thinking: this.$refs['homeInputCpn'].deepthinkType
                    ? '1'
                    : '',
                })
                this.$nextTick(() => {
                  this.$set(
                    this.inputCpnVm,
                    'deepthinkType',
                    this.$refs['homeInputCpn'].deepthinkType
                  )
                })

                this.homeInputValue = ''
              } else {
                this.chatWindow.talk(self.convo)
              }
            } else {
              data.forEach((item, index) => {
                if (item.msg_type == 'question') {
                  this.chatWindow.addBubble(
                    '<span class="bubble-button bubble-pick">' +
                      escapeHtml(item.message_content) +
                      '</span>',
                    function () {},
                    'reply reply-freeform',
                    true,
                    '',
                    item._id.$oid
                  )
                } else if (item.msg_type == 'answer') {
                  let content = item.message_content
                  if (content.indexOf('analyse-title') > -1) {
                    const isLastIndex =
                      data.findIndex((ele) => ele._id.$oid == item._id.$oid) ==
                      data.length - 1
                    if (!item.parameter || (item.parameter && !isLastIndex)) {
                      this.removeCatSelector()
                      this.chatWindow.addBubble(
                        content,
                        function () {},
                        'answer-title-wrap-v2 analyse-title-bubble',
                        true,
                        '',
                        item._id.$oid
                      )
                    } else {
                      if (
                        data.some(
                          (item) =>
                            item.question_id ==
                              data[data.length - 1].question_id &&
                            item.msg_type == 'update_parameter'
                        )
                      ) {
                        this.removeCatSelector()
                        this.chatWindow.addBubble(
                          content,
                          function () {},
                          'answer-title-wrap-v2 analyse-title-bubble',
                          true,
                          '',
                          item._id.$oid
                        )
                        return
                      }
                      const param = JSON.parse(item.parameter)
                      const { cats, plat, title, entity } = param
                      content = this.addFilterContent(param, content)

                      this.chatWindow.addBubble(
                        content,
                        function () {},
                        'answer-title-wrap-v2 analyse-title-bubble',
                        true,
                        '',
                        item._id.$oid
                      )
                      this.questionId = item.question_id
                      // $('.stop-wrap-div').show()
                      this.stopWrapVisible(true)
                      this.addLoader()
                      this.isLock = true
                      this.chatWindow.lock(true)
                    }
                  } else if (content.indexOf('fetch-title') > -1) {
                    this.chatWindow.addBubble(
                      content,
                      function () {},
                      'answer-title-wrap-v2 ',
                      true,
                      '',
                      item._id.$oid
                    )
                  } else if (content.indexOf('generate-title') > -1) {
                    const md = new MarkdownIt({
                      html: true, // 允许解析 HTML
                    })
                    let htmlOutput = md.render(content)
                    htmlOutput += this.registrationText
                    // 输出完整的 HTML，HTML 部分直接保留，Markdown 部分转为 HTML
                    const hasThinkTitle = htmlOutput.includes('think-title')
                    const isThinking = htmlOutput.includes('思考中')
                    if (hasThinkTitle) {
                      if (isThinking) {
                        const imgUrl = require('@/assets/compressed.gif')
                        // 在 think-title 的 div 开始标签后插入 img
                        htmlOutput = htmlOutput.replace(
                          /<div class="think-title">/,
                          `<div class="think-title"><img src="${imgUrl}">`
                        )
                      } else {
                        // 添加 think-done 类并插入图标
                        htmlOutput = htmlOutput.replace(
                          /<div class="think-title">/,
                          '<div class="think-title think-done"><i class="iconfont icon-zhinengyouhua"></i>'
                        )
                      }
                    }
                    const loader =
                      '<span class="loader" style="margin-left: 32px"></span>'
                    this.chatWindow.addBubble(
                      htmlOutput,
                      function () {},
                      'answer-title-wrap-v2 ',
                      true,
                      '',
                      item._id.$oid
                    )
                    setTimeout(() => {
                      // 清理事件监听
                      $(document).off('click', '.think-title.think-done')
                      $(document).on(
                        'click',
                        '.think-title.think-done',
                        function () {
                          const $this = $(this)
                          const $content = $this.next('.think-content')

                          $this.toggleClass('think-fold')
                          $content.slideToggle()
                        }
                      )
                    }, 300)
                  } else {
                    this.chatWindow.addBubble(
                      content,
                      function () {},
                      '',
                      true,
                      '',
                      item._id.$oid
                    )
                  }
                } else if (item.msg_type == 'meta') {
                  this.chatWindow.addBubble(
                    `<img src="${metaImg}" style="width: 12px; height: 12px" />` +
                      item.message_content,
                    function () {},
                    'meta',
                    true,
                    '',
                    item._id.$oid
                  )
                } else if (item.msg_type == 'image') {
                  this.chatWindow.addBubble(
                    `<img src="${item.message_content}" class="preview" style="width: 760px"/>`,
                    function () {},
                    '',
                    true,
                    true,
                    '',
                    item._id.$oid
                  )
                } else if (item.msg_type == 'suggestion') {
                  this.chatWindow.addBubble(
                    item.message_content +
                      `<span class="iconfont icon-yousanjiao" style="margin-left: 5px"></span>`,
                    function () {},
                    'suggest',
                    true,
                    '',
                    item._id.$oid
                  )
                }
                if (index == data.length - 1 && item.msg_type == 'end') {
                  this.questionId = item.question_id
                  this.addDownloadTimeoutId = setTimeout(() => {
                    this.addDownloadBtn()
                  }, 1000)
                }
                this.bubbleIds.push(item._id.$oid)
              })
            }

            if (
              this.$store.state.user.chatStatus.chatId == this.chatId &&
              (this.chatStatus == 'answering' || this.chatStatus == 'waiting')
            ) {
              this.questionId = data[data.length - 1].question_id
              this.getAnswerMethod()
            }
            if (this.chatStatus == 'waiting') {
            }
          }
          window.chatWindow = this.chatWindow
          setTimeout(() => {
            $('.preview').click(function () {
              var img = $(this).attr('src')
              $('#preview-window img').attr('src', img)
              $('#preview-window').fadeIn()
            })
            $('#preview-window').click(function () {
              $(this).fadeOut()
            })
          }, 1000)
        })
      })
    },
    judgeUserAiPay() {
      if (this.loginInfo.wecom_pop_up) {
        return getUserInfo().then((res) => {
          const result = res.result
          return this.$store.dispatch('user/changeLoginInfo', result)
        })
      } else {
        return new Promise((resolve) => {
          resolve()
        })
      }
    },
    async inputCallbackFn(o) {
      if (this.isShare) {
        return
      }
      await this.judgeUserAiPay()
      if (this.loginInfo.wecom_pop_up) {
        this.kfDialogVisible = true
        if (window.mixpanel) {
          mixpanel.track('Free Count Notice')
        }
        return
      }
      if (this.interval) {
        this.$message.error(
          '您还有提问正在回答中，请等待之前的问题回答结束后再尝试'
        )
        return
      }
      if (window.mixpanel) {
        const params = {
          question: o.input,
          userinfo: this.$store.state.user.loginInfo,
          deep_thinking: o.deep_thinking,
        }
        this.updateUserInfo().then(() => {
          window.mixpanel.track('user question', params)
        })
      }
      //输入框问题发送

      this.autoReply()

      postAskChat({
        conv_id: this.chatId,
        content: o.input,
        type: 'question',
        deep_thinking: o.deep_thinking,
      }).then((res) => {
        if (res.status == 'ok') {
          const result = res.result
          if (result.PayGuide) {
            const browserFinger = localStorage.getItem('browserFinger')
            const browserInfo = getBrowserInfo()
            let property = {
              $device_id: mixpanel.get_property('$device_id'),
              $initial_referring_domain: mixpanel.get_property(
                '$initial_referring_domain'
              ),
              $initial_referrer: mixpanel.get_property('$initial_referrer'),
              browser_id: browserFinger ? browserFinger : '',
              ...browserInfo,
            }
            if (this.$store.state.user.isJdUser) {
              this.jdDialogVisible = true
              return
            }
            const params = {
              event_time: getCurrentTimeString(),
              source: 'Answer',
            }
            this.updateUserInfo().then(() => {
              mixpanel.track('Pay Notice Event', params)
            })
            this.showPayDialog = true

            // postPay({
            //   username: this.$store.state.user.loginInfo.username,
            //   property,
            // }).then((res) => {
            //   if (res.status == 'ok') {
            //     const result = res.result
            //     this.orderId = result.order_id
            //     this.yearOrderId = result.year_order_id
            //     this.showPayDialog = false
            //     this.$nextTick(() => {
            //       const params = {
            //         event_time: getCurrentTimeString(),
            //         source: 'Answer',
            //       }
            //       this.updateUserInfo().then(() => {
            //         mixpanel.track('Pay Notice Event', params)
            //       })
            //       this.showPayDialog = true
            //     })
            //   } else {
            //     this.showPayDialog = false
            //   }
            // })
            return
          } else {
            this.showPayDialog = false
          }
          if (result.ServerPayError) {
            this.addErrorBubble()
            return
          }
          if (result && result.title) {
            this.$eventBus.$emit('changeTitle', result.title, this.chatId)
          }
          this.$eventBus.$emit('userInputQuestion')
          this.questionId = result.question_id
          this.getAnswerMethod()
        }
      })
    },
    copyCallbackFn(val) {
      //点击复制
      let inputElement = document.createElement('input')
      inputElement.value = val
      document.body.appendChild(inputElement)
      inputElement.select() //选中文本
      document.execCommand('copy') //执行浏览器复制命令
      inputElement.remove()
      this.$message({
        message: '复制成功',
        type: 'success',
      })
    },
    defaultQuestionCallbackFn(value) {
      this.inputCpnVm.$refs.dynamicInputCpn.inputValue = value
      //点击默认问题发送
    },
    replyCallbackFn(val, copy) {
      //内容渲染后
    },
    suggestCallbackFn(text) {
      this.inputCpnVm.$refs.dynamicInputCpn.inputValue = text
      this.inputCpnVm.$refs.dynamicInputCpn.$refs['chatTextarea'].focus()
    },
    match(key) {
      let self = this
      setTimeout(function () {
        self.chatWindow.talk(self.convo, key) // restart current convo from point found in the answer
      }, 600)
    },
    chatGptReply(value) {
      this.chatWindow.talk(
        {
          chatGpt: {
            says: [value],
            // reply: o.convo[o.standingAnswer].reply,
          },
        },
        'chatGpt'
      )
    },
    getAnswerMethod(type) {
      if (type !== 'stop-params') {
        // $('.stop-wrap-div').show()
        this.stopWrapVisible(true)
        this.isLock = true
        this.chatWindow.lock(true)
      }
      if (type != 'parameter') {
        setTimeout(() => {
          this.addLoader()
        }, 700)
      }
      let chatId = this.chatId
      this.interval = setInterval(() => {
        if (chatId !== this.chatId) {
          return
        }
        postAnswer({
          conv_id: this.chatId,
        })
          .then((res) => {
            this.removeDownloadBtn()
            const result = res.result
            const status = result.status
            const data = _.cloneDeep(JSON.parse(result.data))
            if (data[0].conv_id != this.chatId) {
              return
            }
            this.$store.dispatch('user/changeChatStatus', {
              chatId: this.chatId,
              status,
            })
            if (status == 'ready') {
              clearInterval(this.interval)
              this.interval = ''
              this.isLock = false
              this.chatWindow.lock(false)
              // $('.stop-wrap-div').hide()
              this.stopWrapVisible(false)
              // 清除之前的loader
              // 获取所有class包含 "loader" 的元素
              const loaders = document.querySelectorAll('.loader-wrap')
              // 若要移除元素而非仅移除类名
              Array.from(loaders).forEach((loader) =>
                loader.parentNode.removeChild(loader)
              )
            }
            if (result.side_data) {
              const sideData = JSON.parse(result.side_data)
              this.sideData = sideData
            }
            // 最后一个回答index
            const lastBubbleIdIndex = data.findIndex((item) => {
              return item._id.$oid == this.bubbleIds[this.bubbleIds.length - 1]
            })
            // 当前问题的对话arr
            const currentArr = data.slice(lastBubbleIdIndex + 1)
            // meta图标
            const metaImg = require('../assets/img/meta_check.png')
            // 目前前端更新到页面的item
            const lastItem = data[lastBubbleIdIndex]
            // 如果是回答, 就需要随时更新
            if (lastItem && lastItem.msg_type == 'answer') {
              const questionArr = data.filter(
                (item) => item.question_id == lastItem.question_id
              )
              const lastItemIndex = questionArr.findIndex(
                (item) => item._id.$oid == lastItem._id.$oid
              )
              const oldQuestionArr = questionArr.slice(0, lastItemIndex + 1)
              oldQuestionArr.forEach((item) => {
                const lastBubbleId = item._id.$oid
                function selectElementByClassName(className) {
                  // 如果类名以数字开头，需要进行转义
                  if (/^\d/.test(className)) {
                    // 对首数字进行转义
                    className = className.replace(
                      /^\d/,
                      (digit) => `\\3${digit} `
                    )
                  }
                  return document.querySelector(`.${className}`)
                }
                const lastBubble = selectElementByClassName(lastBubbleId)

                let content = item.message_content
                if (content.indexOf('analyse-title') > -1) {
                  const isLastIndex =
                    data.findIndex((ele) => ele._id.$oid == item._id.$oid) ==
                    data.length - 1
                  if (!item.parameter || (item.parameter && !isLastIndex)) {
                    this.removeCatSelector()
                    lastBubble.innerHTML = content
                  } else if (
                    data.some(
                      (item) =>
                        item.question_id == data[data.length - 1].question_id &&
                        item.msg_type == 'update_parameter'
                    )
                  ) {
                    this.removeCatSelector()
                    lastBubble.innerHTML = content
                  } else {
                    const param = JSON.parse(item.parameter)
                    const { cats, plat, title, entity } = param
                    content = this.addFilterContent(param, content)

                    lastBubble.innerHTML = content

                    this.$nextTick(() => {
                      this.addCatTreeSelector(param)
                    })

                    this.questionId = item.question_id
                    // $('.stop-wrap-div').show()
                    this.stopWrapVisible(true)
                    clearInterval(this.interval)
                    this.interval = ''
                    this.addLoader()
                    this.isLock = true
                    this.chatWindow.lock(true)
                  }
                } else if (content.indexOf('fetch-title') > -1) {
                  lastBubble.innerHTML = content
                  isFetchDone()
                } else if (content.indexOf('generate-title') > -1) {
                  const md = new MarkdownIt({
                    html: true, // 允许解析 HTML
                  })

                  let htmlOutput = md.render(content)

                  // htmlOutput +=
                  //   '<span class="loader" style="margin-left: 32px"></span>'
                  if (htmlOutput.indexOf('answer-generate-content') > -1) {
                    htmlOutput += this.registrationText
                  }
                  const hasThinkTitle = htmlOutput.includes('think-title')
                  const isThinking = htmlOutput.includes('思考中')
                  if (hasThinkTitle) {
                    if (isThinking) {
                      const imgUrl = require('@/assets/compressed.gif')
                      // 在 think-title 的 div 开始标签后插入 img
                      htmlOutput = htmlOutput.replace(
                        /<div class="think-title">/,
                        `<div class="think-title"><img src="${imgUrl}">`
                      )
                    } else {
                      // 添加 think-done 类并插入图标
                      htmlOutput = htmlOutput.replace(
                        /<div class="think-title">/,
                        '<div class="think-title think-done"><i class="iconfont icon-zhinengyouhua"></i>'
                      )
                    }
                  }

                  if (!htmlOutput) {
                    return
                  }
                  // console.log(htmlOutput)
                  // 输出完整的 HTML，HTML 部分直接保留，Markdown 部分转为 HTML
                  lastBubble.innerHTML = htmlOutput
                  // 折叠之前的 analyse-title
                  this.foldPreviousAnalyseTitle()

                  this.$nextTick(() => {
                    // 清理事件监听
                    $(document).off('click', '.think-title.think-done')
                    $(document).on(
                      'click',
                      '.think-title.think-done',
                      function () {
                        const $this = $(this)
                        const $content = $this.next('.think-content')

                        $this.toggleClass('think-fold')
                        $content.slideToggle()
                      }
                    )
                    if (
                      data.findIndex((ele) => ele._id.$oid == item._id.$oid) ==
                      data.length - 1
                    ) {
                      if (hasThinkTitle) {
                        if (isThinking) {
                          const thinkAreas = $(
                            `[question_id="${item._id.$oid}"] .think-area`
                          )
                          const loaderSpan = document.createElement('span')
                          loaderSpan.className = 'loader'
                          loaderSpan.style.marginLeft = '32px'
                          thinkAreas[0].appendChild(loaderSpan)
                          $('.loader-wrap').hide()
                        } else {
                          const generateAreas = $(
                            `[question_id="${item._id.$oid}"] .answer-generate-content`
                          )
                          const loaderSpan = document.createElement('span')
                          loaderSpan.className = 'loader'
                          loaderSpan.style.marginLeft = '32px'
                          generateAreas[0].appendChild(loaderSpan)
                          $('.loader-wrap').hide()
                        }
                      } else {
                        $('.loader-wrap').show()
                      }
                    } else {
                      $('.loader-wrap').show()
                    }
                  })
                }
              })
            }
            currentArr.forEach((item, index) => {
              if (item.msg_type == 'end') {
                clearInterval(this.interval)
                this.interval = ''
                this.isLock = false
                this.chatWindow.lock(false)
                // $('.stop-wrap-div').hide()
                this.stopWrapVisible(false)
                // 清除之前的loader
                // 获取所有class包含 "loader" 的元素
                const loaders = document.querySelectorAll('.loader-wrap')
                // 若要移除元素而非仅移除类名
                Array.from(loaders).forEach((loader) =>
                  loader.parentNode.removeChild(loader)
                )
                if (index == currentArr.length - 1 && item.msg_type == 'end') {
                  setTimeout(() => {
                    this.addDownloadBtn()
                  }, 1000)
                }
              } else if (item.msg_type == 'answer') {
                let content = item.message_content
                if (content.indexOf('analyse-title') > -1) {
                  const isLastIndex =
                    data.findIndex((ele) => ele._id.$oid == item._id.$oid) ==
                    data.length - 1
                  if (!item.parameter || (item.parameter && !isLastIndex)) {
                    this.removeCatSelector()
                    this.chatWindow.addBubble(
                      content,
                      function () {},
                      'answer-title-wrap-v2 analyse-title-bubble',
                      true,
                      '',
                      item._id.$oid
                    )
                  } else {
                    const param = JSON.parse(item.parameter)
                    const { cats, plat, title, entity } = param
                    content = this.addFilterContent(param, content)

                    this.chatWindow.addBubble(
                      content,
                      function () {},
                      'answer-title-wrap-v2 analyse-title-bubble',
                      true,
                      '',
                      item._id.$oid
                    )

                    this.questionId = item.question_id
                    this.$nextTick(() => {
                      this.addCatTreeSelector(param)
                    })
                    // $('.stop-wrap-div').show()
                    this.stopWrapVisible(true)
                    clearInterval(this.interval)
                    this.interval = ''
                    this.addLoader()
                    this.isLock = true
                    this.chatWindow.lock(true)
                  }
                } else if (content.indexOf('fetch-title') > -1) {
                  this.chatWindow.addBubble(
                    content,
                    function () {},
                    'answer-title-wrap-v2 ',
                    true,
                    '',
                    item._id.$oid
                  )
                } else if (content.indexOf('generate-title') > -1) {
                  const md = new MarkdownIt({
                    html: true, // 允许解析 HTML
                  })
                  let htmlOutput = md.render(content)
                  // 输出完整的 HTML，HTML 部分直接保留，Markdown 部分转为 HTML
                  const hasThinkTitle = htmlOutput.includes('think-title')
                  const isThinking = htmlOutput.includes('思考中')
                  if (hasThinkTitle) {
                    if (isThinking) {
                      const imgUrl = require('@/assets/compressed.gif')
                      // 在 think-title 的 div 开始标签后插入 img
                      htmlOutput = htmlOutput.replace(
                        /<div class="think-title">/,
                        `<div class="think-title"><img src="${imgUrl}">`
                      )
                    } else {
                      // 添加 think-done 类并插入图标
                      htmlOutput = htmlOutput.replace(
                        /<div class="think-title">/,
                        '<div class="think-title think-done"><i class="iconfont icon-zhinengyouhua"></i>'
                      )
                    }
                  }

                  this.chatWindow.addBubble(
                    htmlOutput,
                    function () {},
                    'answer-title-wrap-v2 ',
                    true,
                    '',
                    item._id.$oid
                  )
                  setTimeout(() => {
                    this.$nextTick(() => {
                      // 清理事件监听
                      $(document).off('click', '.think-title.think-done')
                      $(document).on(
                        'click',
                        '.think-title.think-done',
                        function () {
                          const $this = $(this)
                          const $content = $this.next('.think-content')

                          $this.toggleClass('think-fold')
                          $content.slideToggle()
                        }
                      )
                    })
                  }, 300)
                } else {
                  this.chatWindow.addBubble(
                    item.message_content,
                    function () {},
                    '',
                    true,
                    '',
                    item._id.$oid
                  )
                }
                this.questionId = item.question_id
                this.addLoader()
              } else if (item.msg_type == 'meta') {
                this.chatWindow.addBubble(
                  `<img src="${metaImg}" style="width: 12px; height: 12px" />` +
                    item.message_content,
                  function () {},
                  'meta',
                  true,
                  '',
                  item._id.$oid
                )
                this.addLoader()
              } else if (item.msg_type == 'parameter') {
              } else if (item.msg_type == 'image') {
                this.chatWindow.addBubble(
                  `<img src="${item.message_content}" class="preview" style="width: 750px"/>`,
                  function () {},
                  '',
                  true,
                  true,
                  item._id.$oid
                )
                this.addLoader()
              } else if (item.msg_type == 'suggestion') {
                this.chatWindow.addBubble(
                  item.message_content +
                    `<span class="iconfont icon-yousanjiao" style="margin-left: 5px"></span>`,
                  function () {},
                  'suggest',
                  true,
                  '',
                  item._id.$oid
                )
                this.addLoader()
              }
              this.bubbleIds.push(item._id.$oid)
            })
          })
          .catch((err) => {
            clearInterval(this.interval)
            this.interval = ''
            this.isLock = false
            this.chatWindow.lock(false)
            // $('.stop-wrap-div').hide()
            this.stopWrapVisible(false)
            // 清除之前的loader
            // 获取所有class包含 "loader" 的元素
            const loaders = document.querySelectorAll('.loader-wrap')
            // 若要移除元素而非仅移除类名
            Array.from(loaders).forEach((loader) =>
              loader.parentNode.removeChild(loader)
            )
          })
      }, 2000)
    },
    clearBubble() {
      this.chatWindow = null
      let content = document.getElementById('chat')
      while (content && content.hasChildNodes()) {
        content.removeChild(content.firstChild)
      }
      if (this.interval) {
        clearInterval(this.interval)
        this.interval = ''
      }
      this.bubbleIds = []
      this.treeSelectedData = []
    },
    autoReply() {
      this.chatWindow.lock(true)
      this.isLock = true
    },
    initDefaultQuestion() {
      return new Promise((resolve) => {
        postDefaultQuestion().then((res) => {
          if (res.status == 'ok') {
            const result = res.result
            this.defaultQuestions = result.question
            this.chatWindow.addQuestion(result.question)
            resolve()
          }
        })
      })
    },
    initHomeQuestion() {
      postDefaultQuestion().then((res) => {
        if (res.status == 'ok') {
          const result = res.result
          this.defaultQuestions = result.question
          this.$store.dispatch('user/changeAsideData', result.aside_data)
        }
      })
    },
    sendDefaultQuestion(item) {
      this.chatWindow.activelySend(item)
      this.autoReply()
      this.isLock = true
      postAskChat({
        conv_id: this.chatId,
        content: item,
        type: 'question',
      }).then((res) => {
        if (res.status == 'ok') {
          const result = res.result
          if (result && result.title) {
            this.$eventBus.$emit('changeTitle', result.title, this.chatId)
          }
          this.getAnswerMethod()
        }
      })
      this.showQuestions = false
    },
    addFilterContent(param, content) {
      const { cats, plat, title, entity, start, end } = param
      if (start && end) {
        this.catTime = [start, end]
      }
      let brand = param.brand ? param.brand : ''
      let currentPlat = plat
      const catFilterStr = generateCatFilterStr(param)
      return insertContent(content, `<div class="filter-panel-area"></div>`)
    },
    addFifteenBubble() {
      // 清除之前的loader
      // 获取所有class包含 "loader" 的元素
      const loaders = document.querySelectorAll('.loader-wrap')
      // 若要移除元素而非仅移除类名
      Array.from(loaders).forEach((loader) =>
        loader.parentNode.removeChild(loader)
      )
      this.chatWindow.addBubble(
        `<span class="fifteen-bubble">不确定如何精准筛选数据？可以<span class="help-link">联系客服</span>，获得帮助。精准筛选数据，才能获得满意的答案哦！</span>`,
        function () {},
        'fifteen-bubble-wrap'
      )
      this.addLoader()
    },
    removeFifteenBubble() {
      const loaders = document.querySelectorAll('.fifteen-bubble-wrap')
      // 若要移除元素而非仅移除类名
      Array.from(loaders).forEach((loader) =>
        loader.parentNode.removeChild(loader)
      )
      if (this.fifteenTimeout) {
        clearTimeout(this.fifteenTimeout)
        this.fifteenTimeout = ''
      }
    },
    addInputHelpPoP() {
      const pop = $('#question-help-pop')
      let poptimeout, icontimeout
      $('#chat-help-icon').hover(
        function () {
          if (icontimeout) {
            clearTimeout(icontimeout)
          }
          if (poptimeout) {
            clearTimeout(poptimeout)
          }
          pop
            .css({
              top: $(this).offset().top + $(this).outerHeight() - 80,
              left: $(this).offset().left,
            })
            .show()
        },
        function () {
          icontimeout = setTimeout(() => {
            pop.hide()
          }, 800)
        }
      )
      pop.hover(
        function () {
          if (poptimeout) {
            clearTimeout(poptimeout)
          }
          if (icontimeout) {
            clearTimeout(icontimeout)
          }
          pop
            .css({
              top:
                $('#chat-help-icon').offset().top +
                $('#chat-help-icon').outerHeight() -
                80,
              left: $('#chat-help-icon').offset().left,
            })
            .show()
        },
        function () {
          poptimeout = setTimeout(() => {
            pop.hide()
          }, 800)
        }
      )
    },
    confirmHandler(params) {
      const { plat, entity, brand, title, cats } = params
      if (cats.length == 0) {
        this.$message.warning('最少选择1个类目后提交')
        return
      }
      // 隐藏parameter弹窗
      $('.confirm-params-area').hide()

      if (this.paramTimeout) {
        clearTimeout(this.paramTimeout)
        this.paramTimeout = ''
      }
      const param = {
        title,
        brand,
        cats,
        plat,
        entity,
        start: this.catTime[0],
        end: this.catTime[1],
      }
      postAskChat({
        conv_id: this.chatId,
        content: JSON.stringify(param),
        question_id: this.questionId,
        type: 'parameter',
      })
        .then((res) => {
          if (res.status == 'ok') {
            this.removeCatSelector()
            this.getAnswerMethod('parameter')
          }
        })
        .catch((err) => {
          this.$message({
            message: err.data.error_msg,
            type: 'warning',
          })
          $('.confirm-params-area').show()
        })
    },
    stopCallbackFn() {
      // this.isLock = false
      // this.chatWindow.lock(false)
      // $('.stop-wrap-div').hide()
      this.stopWrapVisible(false)
      this.removeFifteenBubble()
      // 类目选择器时清除规则
      if (document.querySelectorAll('.confirm-params-area').length > 0) {
        clearTimeout(this.paramTimeout)
        this.paramTimeout = ''
        // 去掉parameter弹窗
        // document
        //   .querySelectorAll('.confirm-params-area')
        //   .forEach(function (element) {
        //     element.remove()
        //   })
        this.removeCatSelector()
        // 清除之前的loader
        // 获取所有class包含 "loader" 的元素
        const loaders = document.querySelectorAll('.loader-wrap')
        // 若要移除元素而非仅移除类名
        Array.from(loaders).forEach((loader) =>
          loader.parentNode.removeChild(loader)
        )
        postAskChat({
          conv_id: this.chatId,
          question_id: this.questionId,
          content: '',
          type: 'stop',
        }).then((res) => {
          if (res.status == 'ok') {
            this.getAnswerMethod('stop-params')
          }
        })
      } else {
        postAskChat({
          conv_id: this.chatId,
          content: '',
          type: 'stop',
          question_id: this.questionId,
        }).then((res) => {
          if (res.status == 'ok') {
          }
        })
      }
    },
    addLoader() {
      // 清除之前的loader
      // 获取所有class包含 "loader" 的元素
      const loaders = document.querySelectorAll('.loader-wrap')
      // 若要移除元素而非仅移除类名
      Array.from(loaders).forEach((loader) =>
        loader.parentNode.removeChild(loader)
      )
      this.chatWindow.addBubble(
        '<div class="loader"></div>',
        function () {},
        'loader-wrap'
      )
      $('.preview').click(function () {
        var img = $(this).attr('src')
        $('#preview-window img').attr('src', img)
        $('#preview-window').fadeIn()
      })
      $('#preview-window').click(function () {
        $(this).fadeOut()
      })
      this.addHelpIcon()
      let $bubbleWrap = $('.bubble-wrap')
      if ($bubbleWrap[0] && $bubbleWrap[0].scrollHeight) {
        // 将 Y 轴滚动条滚动到最下端
        $bubbleWrap.scrollTop($bubbleWrap[0].scrollHeight - 30)
      }
    },
    addHelpIcon() {},
    addErrorBubble() {
      this.chatWindow.addBubble(
        '<span style="color: red">服务器错误，请通知产品经理</span>'
      )
    },
    payDialogClose() {
      window.location.reload()
      this.isLock = false
      if (this.chatWindow) {
        this.chatWindow.lock(false)
      }
    },
    async handleHomeEnter() {
      if (!this.homeInputValue) {
        return
      }
      if (!this.loginInfo) {
        if (window.mixpanel) {
          mixpanel.track('Not Login User Question', {
            question: this.homeInputValue,
          })
        }
        this.$eventBus.$emit('showLoginDialog')
      } else {
        await this.judgeUserAiPay()
        if (this.loginInfo.wecom_pop_up) {
          this.kfDialogVisible = true
          if (window.mixpanel) {
            mixpanel.track('Free Count Notice')
          }
          return
        }
        postNewChat().then((res) => {
          if (res.status == 'ok') {
            const result = res.result
            this.$eventBus.$emit('homeNewChat', result)
          }
        })
      }
      let query = getObjFromUrl(window.location.hash)
      if (query && query.f && query.cb) {
        window.zhad.push({ eventtype: 'js_ask' })
      }
    },
    clearHomeInput() {
      this.homeInputValue = ''
    },
    questionClick(ele) {
      this.$refs['homeInputCpn'].inputValue = ele.content
      this.$refs['homeInputCpn'].$refs.chatTextarea.focus()
      this.homeInputValue = ele.content
    },
    jumpBlankLink(link) {
      if (
        link.indexOf('fenxi') > -1 ||
        link.indexOf('social') > -1 ||
        link.indexOf('chance') > -1 ||
        link.indexOf('comment') > -1 ||
        link.indexOf('oversea') > -1
      ) {
        const menueData = this.$store.state.user.menuData
        let event_question = menueData.find((item) => item.index == this.chatId)
        if (!event_question) {
          event_question = this.$store.state.user.asideData.find(
            (item) => item.index == this.chatId
          )
        }
        const param = {
          event_url: link,
          event_question: event_question ? event_question.label : '',
          event_time: getCurrentTimeString(),
        }
        mixpanel.track('ai2cmi event', param)
        this.jumpLink = link
        this.$refs.jumpLinkDialog.dialogVisible = true
      } else if (link.indexOf('logout') > -1) {
        jumpToSelf(link)
      } else if (link) {
        jumpToBlank(link)
      }
    },
    // 判断是否为oversea 平台.
    isOverseaPlat(plat) {
      return ['亚马逊', '虾皮', '来赞达'].some((brand) => plat.includes(brand))
    },
    paySuccess() {},
    updateUserInfo() {
      return getUserInfo().then((res) => {
        const browserFinger = localStorage.getItem('browserFinger')
        let visitorId = res.result.username
        let infoObj = {
          ...res.result,
          browser_fingerprint: browserFinger ? browserFinger : '', // 浏览器id
          name: visitorId,
        }
        mixpanel.people.set(infoObj)
        return
      })
    },
    addDownloadBtn() {
      this.chatWindow.addBubble(
        `
        <div style="display: flex; color: blue">
          <span class="bubble-download">
            <i class="iconfont icon-xiazai" style="margin-right: 6px"></i>下载
          </span>
          <span class="bubble-share">
            <i class="iconfont icon-share" style="margin-left: 10px;margin-right: 6px"></i>分享
          </span>
          <span class="bubble-feishu-share">
            <i class="iconfont icon-baogao-copy" style="margin-left: 10px;margin-right: 6px"></i>复制飞书文档链接
          </span>
        </div>
        `,
        function () {},
        'meta bubble-download-wrap',
        true
      )

      $('.bubble-download').click((event) => {
        this.downloadDoc()
      })
      $('.bubble-share').click((event) => {
        this.handleShare()
      })
      $('.bubble-feishu-share').click((event) => {
        this.handleFeishuShare()
      })
      const pop = $('#download-pop')
      const sharePop = $('#share-pop')
      $('.bubble-download').hover(
        function () {
          pop
            .css({
              top: $(this).offset().top + $(this).outerHeight() - 10,
              left: $(this).offset().left,
            })
            .show()
        },
        function () {
          pop.hide()
        }
      )
      $('.bubble-share').hover(
        function () {
          sharePop
            .css({
              top: $(this).offset().top + $(this).outerHeight() - 10,
              left: $(this).offset().left,
            })
            .show()
        },
        function () {
          sharePop.hide()
        }
      )
    },
    async handleShare() {
      try {
        const chatId = this.$store.state.user.chatId
        const f = `share_${chatId}`
        await navigator.clipboard.writeText(`${location.origin}/#/app?f=${f}`)
        this.$message.success('分享链接已复制至剪贴板')
      } catch (err) {
        this.$message.error('分享失败！请重试或联系运营')
      }
    },
    async handleFeishuShare() {
      if (this.feishuLoading) return
      this.feishuLoading = true
      $('.bubble-feishu-share').css({
        color: '#d0d0d0',
        cursor: 'not-allowed',
      })
      try {
        const chatId = this.$store.state.user.chatId
        const response = await postShareDoc({
          conv_id: chatId,
          date: DateTime.now().setZone('Asia/Shanghai').toISODate(),
          last_question_id: this.questionId,
        })

        if (response && response.result && response.result.url) {
          await navigator.clipboard.writeText(response.result.url)
          this.$message.success('分享链接已复制至剪贴板')
        } else {
          // 接口返回失败
          this.$message.error(
            response.message ? response.message : '获取共享文档失败'
          )
        }
        this.feishuLoading = false
        $('.bubble-feishu-share').css({
          color: '#2e54ed',
          cursor: 'pointer',
        })
      } catch (err) {
        this.$message.error('分享失败！请重试或联系运营')
        this.feishuLoading = false
        $('.bubble-feishu-share').css({
          color: '#2e54ed',
          cursor: 'pointer',
        })
      }
    },
    removeDownloadBtn() {
      if (this.addDownloadTimeoutId) {
        clearTimeout(this.addDownloadTimeoutId)
      }
      this.downloading = false
      this.downloadText = '将对话内容下载为文档'
      // 获取所有class包含 "bubble-download-wrap" 的元素
      const wraps = document.querySelectorAll('.bubble-download-wrap')
      // 若要移除元素而非仅移除类名
      Array.from(wraps).forEach((wrap) => wrap.parentNode.removeChild(wrap))
    },
    downloadDoc() {
      // 未登录用户弹出登录框
      if (!this.loginInfo) {
        this.$eventBus.$emit('showLoginDialog')
        return
      }
      if (this.downloading) {
        // 禁止重复点击下载
        return
      }
      $('.bubble-download').css({
        color: '#d0d0d0',
        cursor: 'not-allowed',
      })
      this.downloading = true
      this.downloadText = '下载中...'
      postAskChat({
        conv_id: this.chatId,
        type: 'download',
        content: '',
      })
        .then((res) => {
          const link = res.result.url
          this.downloadText = '将对话内容下载为文档'
          if (link) {
            downloadFileByLink(link).then(() => {
              this.downloading = false
              this.$forceUpdate()
            })
          } else {
            this.$message.error(
              res.result.message ? res.result.message : '生成文档失败'
            )
          }
          $('.bubble-download').css({
            color: '#2e54ed',
            cursor: 'pointer',
          })
        })
        .catch((error) => {
          if (error.backMsg) {
            this.$message.error(error.backMsg)
          } else {
            this.$message.error('生成文档失败')
          }
          this.downloading = false
          this.downloadText = '将对话内容下载为文档'
          $('.bubble-download').css({
            color: '#2e54ed',
            cursor: 'pointer',
          })
        })
    },
    containsDefault(str) {
      return /default/i.test(str)
    },
    // 折叠分析问题模块
    foldPreviousAnalyseTitle() {
      const analyseTitles = document.querySelectorAll('.answer-analyse-title')
      if (analyseTitles.length > 0) {
        const lastAnalyseTitle = analyseTitles[analyseTitles.length - 1]
        lastAnalyseTitle.classList.add('fold-bubble')
      }
    },
  },
  watch: {
    '$store.state.user.chatId': {
      handler(newVal, oldVal) {
        let query = getObjFromUrl(window.location.hash)
        const share_id = extractShareId(query)
        if (newVal != share_id) {
          this.isShare = false
        }
        this.removeFifteenBubble()
        this.questionId = ''
        this.isLock = false
        if (!newVal) {
          this.isNullChatId = true
          this.showInvite = false
        } else if (newVal == 'setup') {
          this.isNullChatId = false
          this.chatId = newVal
          this.clearBubble()
          this.showSet = true
          this.showInvite = false
        } else if (newVal == 'invite') {
          this.isNullChatId = false
          this.chatId = newVal
          this.clearBubble()
          this.showSet = false
          this.showInvite = true
        } else {
          this.isNullChatId = false
          this.chatId = newVal
          this.showSet = false
          this.showInvite = false
          this.clearBubble()
          this.initChatBubble()
        }
      },
      immediate: true,
    },
    '$store.state.user.loginInfo': {
      handler(newVal, oldVal) {
        if (newVal && newVal.new_AI_user) {
          this.newAIUser = true
        } else {
          this.newAIUser = false
        }
      },
      immediate: true,
    },
    homeInputValue: {
      handler(newVal, oldVal) {
        this.$store.dispatch('user/changeHomeInputValue', newVal)
      },
      immediate: true,
    },
    '$route.query': {
      handler(newVal) {
        if (newVal.homeInputValue && !this.homeInputValue) {
          this.homeInputValue = decodeURIComponent(
            newVal.homeInputValue.replace(/<.*?>/g, ' ')
          )
        }
        if (newVal.page == 'invite' && !this.$store.state.user.chatId) {
          this.$store.dispatch('user/changeChatId', 'invite')
        }
      },
      immediate: true,
    },
    showRightAside(newVal, oldVal) {
      if (newVal) {
        const bubbleWrap = document.querySelector('.bot-bubble-wrap')
        const inputWrap = document.querySelector('.input-wrap')
        const stopWrap = document.querySelector('.stop-wrap-div')

        if (bubbleWrap) {
          bubbleWrap.style.setProperty('padding-right', '400px', 'important')
        }
        if (inputWrap) {
          inputWrap.style.setProperty('padding-right', '400px', 'important')
        }
        if (stopWrap) {
          stopWrap.style.setProperty('padding-right', '400px', 'important')
        }
      } else {
        const bubbleWrap = document.querySelector('.bot-bubble-wrap')
        const inputWrap = document.querySelector('.input-wrap')
        const stopWrap = document.querySelector('.stop-wrap-div')

        if (bubbleWrap) {
          bubbleWrap.style.setProperty('padding-right', '10px', 'important')
        }
        if (inputWrap) {
          inputWrap.style.setProperty('padding-right', '0px', 'important')
        }
        if (stopWrap) {
          stopWrap.style.setProperty('padding-right', '0px', 'important')
        }
      }
    },
    sideData(newVal) {
      if (this.questionId) {
        this.showSideData = newVal
          .filter((item) => item.question_id == this.questionId)
          .map((item) => {
            const md = new MarkdownIt({
              html: true, // 允许解析 HTML
            })
            // if (item.message_content.length > 500) {
            //   item.message_content = item.message_content.slice(0, 501) + '...'
            // }
            let htmlOutput = md.render(item.message_content)

            item.message_content = htmlOutput
            return item
          })
        if (this.showSideData.length > 0 && !this.user_click_left_side) {
          this.showRightAsideMethods(true, this.questionId)
        }
      } else {
        this.showSideData = newVal.map((item) => {
          const md = new MarkdownIt({
            html: true, // 允许解析 HTML
          })
          // if (item.message_content.length > 500) {
          //   item.message_content = item.message_content.slice(0, 501) + '...'
          // }
          let htmlOutput = md.render(item.message_content)

          item.message_content = htmlOutput
          return item
        })
      }
    },
  },
}
</script>

<style lang="less">
.title-popup {
  width: 350px;
  font-size: 14px;
  position: absolute;
  top: -100px;
  left: -260px;
  background-color: #fff;
  border: 1px solid #ccc;
  padding: 20px;
  border-radius: 5px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  z-index: 1000;
  text-align: center;
  .title-explain {
    color: #3963f3;
    text-align: left;
    font-weight: 400;
    line-height: 20px;
    font-size: 14px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .el-icon-warning {
      margin-right: 5px;
      font-size: 18px;
    }
  }
  .desc-div {
    font-size: 14px;
    margin: 15px 0;
    text-align: left;
    .content {
      font-weight: bolder;
    }
    .desc {
      font-weight: 200;
      font-size: 14px;
    }
  }
}
html {
  font-size: 12px; /* 设置根元素的 font-size */
}
.side-item-img {
  width: 350px;
}
.ai-side {
  cursor: pointer;
  color: blue;
}
.help-link {
  text-decoration: underline;
  cursor: pointer;
}
.login-area {
  width: 100%;
  justify-content: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 10px;
  .login-sub-desc {
    // color: #2f4eff;
    font-size: 16px;
    margin-top: 15px;
    font-weight: bold;
  }
}
.el-icon-question {
  color: #3a63f3;
  margin-left: 5px;
  cursor: pointer;
}
body {
  .el-textarea__inner {
    display: block;
    box-sizing: border-box;
    margin: 0 auto;
    width: 800px;
    // min-width: 80%;
    min-height: 48px;
    // max-width: calc(100% - 300px);
    max-height: 74px;
    font-family: inherit;
    color: #1d2043;
    background: white;
    font-size: 1em;
    letter-spacing: 0.5px;
    font-weight: 400;
    // margin: 10px 5%;
    border: none;
    padding: 13px 42px 13px 16px;
    outline: none;
    // box-shadow: 0 0 0 1px #d0d0d0 inset;
    resize: none;
    border-radius: 10px;
  }
}
.home-page {
  display: flex;
  height: 100%;
  flex-direction: column;
  -webkit-box-pack: center;
  // justify-content: flex-start;
  -webkit-box-align: center;
  align-items: center;
  background-color: #f4f5fa;
  width: 100%;
  // margin-top: 40px;
  .title-area {
    // flex: 1;
    // margin-top: -200px;
    // margin-bottom: 20px;
    width: 800px;
    margin: 0 auto;
    margin-bottom: 20px;
    margin-top: 20px;
    text-align: center;
    .title {
      font-size: 30px;
      font-weight: bolder;
      color: #1d2043;
      letter-spacing: 4px;
      margin-bottom: 5px;
    }
    .sub-title {
      font-size: 16px;
    }
  }
  // .content-area {
  //   width: 800px;
  //   text-align: center;
  //   font-size: 16px;
  // }
  .tips-area {
    // flex: 1;
    background-color: #fff;
    border-radius: 10px;
    width: 800px;
    height: 36px;
    display: flex;
    align-items: center;
    img {
      margin-right: 10px;
      margin-left: 20px;
    }
    color: #1d2043;
    font-size: 14px;
    margin-bottom: 20px;
    letter-spacing: 3px;
    margin-top: 20px;
  }
  .default-questions-area {
    margin-bottom: 20px;
    .default-questions-card {
      .questions-header {
        letter-spacing: 2px;
      }
      .question-item {
        font-size: 12px;
        padding: 0 16px;
      }
    }
  }
  .input-area {
    width: 800px;
    margin-top: auto;
    position: relative;
  }
  .input-area .el-textarea__inner {
    font-family: inherit;
  }
  .input-area .el-textarea__inner::-webkit-input-placeholder {
    color: #a8a8a8;
    text-shadow: none;
    font-family: inherit;
  }
  .input-area .el-textarea__inner::-moz-placeholder {
    color: #a8a8a8;
    text-shadow: none;
    font-family: inherit;
  }
  .bot-bubble-wrap {
    .bubble {
      font-size: 12px;
      letter-spacing: 2px;
    }
  }
}
.inner-container {
  height: 100%;
  position: relative;

  .side-show-button.right-button {
    position: absolute;
    top: 100px;
    right: 20px;
  }

  /* CSS */
  .side-show-button {
    background-color: initial;
    background-image: linear-gradient(-180deg, #ff7e31, #e62c03);
    border-radius: 6px;
    box-shadow: rgba(0, 0, 0, 0.1) 0 2px 4px;
    color: #ffffff;
    cursor: pointer;
    display: inline-block;
    font-family: inherit;
    height: 50px;
    line-height: 50px;
    outline: 0;
    overflow: hidden;
    padding: 0 20px;
    pointer-events: auto;
    text-align: center;
    touch-action: manipulation;
    user-select: none;
    -webkit-user-select: none;
    vertical-align: top;
    white-space: nowrap;
    width: 50px;
    border-radius: 50%;
    z-index: 9999;
    border: 0;
    transition: box-shadow 0.2s;
  }

  .side-show-button:hover {
    box-shadow: rgba(253, 76, 0, 0.5) 0 3px 8px;
  }

  .inner-aside {
    width: 260px !important;
    box-shadow: 4px 6px 8px 0px rgba(6, 10, 50, 0.1);
    z-index: 9;
    background: #070b2f;
  }

  .inner-container2 {
    height: 100%;
    background-color: #f4f5fa; //rgb(238, 241, 246);
    flex-direction: column;

    .header {
      padding: 0;
      height: auto !important;
      width: 100%;
      z-index: 10;

      .header-one {
        padding: 0 24px 0 12px;
        height: auto !important;
        width: 100%;
        min-height: 60px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        background-color: #f4f5f7;
        box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
        //padding: 0 24px;
        z-index: 9;

        .brand {
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          justify-content: flex-start;
          padding: 6px 0;
          gap: 6px;

          .tagBar {
            height: 30px;
            border-radius: 2px;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #fff;

            .el-tag {
              font-size: 14px;
              font-family: inherit;
              color: #fff;
              line-height: 19px;
            }
          }

          .plat {
            height: 30px;
            background: #3a63f3;
            border-radius: 2px;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #fff;

            span {
              font-size: 14px;
              font-family: inherit;
              color: #fff;
              padding: 0 6px;
            }
          }

          .brandName {
            background: #29b36e;
            height: 30px;
            border-radius: 2px;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #fff;

            .el-tag {
              font-size: 14px;
              font-family: inherit;
              color: #fff;
              line-height: 19px;
            }

            .el-tag__close {
              color: #fff;
              // &:hover{
              //     background-color: #67c23a;
              // }
            }

            .el-icon-close {
              top: 0;
            }
          }

          .ruleName {
            background: #80b436;
            height: 30px;
            border-radius: 2px;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #fff;

            .el-tag {
              font-size: 14px;
              font-family: inherit;
              color: #fff;
              line-height: 19px;
            }

            .el-tag__close {
              color: #fff;
              // &:hover{
              //     background-color: #67c23a;
              // }
            }

            .el-icon-close {
              top: 0;
            }
          }

          .ruleName {
            background: #80b436;
            height: 30px;
            border-radius: 2px;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #fff;

            .el-tag {
              font-size: 14px;
              font-family: inherit;
              color: #fff;
              line-height: 19px;
            }

            .el-tag__close {
              color: #fff;
              // &:hover{
              //     background-color: #67c23a;
              // }
            }

            .el-icon-close {
              top: 0;
            }
          }
          .commentName {
            background: rgba(72, 219, 192, 0.3);
            height: 30px;
            border-radius: 2px;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #3a63f3;

            .el-tag {
              font-size: 14px;
              font-family: inherit;
              color: #3a63f3;
              line-height: 19px;
            }

            .el-tag__close {
              color: #3a63f3;
              // &:hover{
              //     background-color: #67c23a;
              // }
            }

            .el-icon-close {
              top: 0;
            }
          }

          .shopName {
            background: #5bc0de;
            height: 30px;
            border-radius: 2px;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #fff;

            .el-tag {
              font-size: 14px;
              font-family: inherit;
              color: #fff;
              line-height: 19px;
            }
          }

          .selectedType {
            display: flex;
            align-items: center;
            height: 27px;
            background: rgba(72, 219, 192, 0.3);
            border-radius: 2px;

            .el-tag {
              font-size: 14px;
              font-family: inherit;
              color: #fff;
              line-height: 19px;
            }
          }

          .selectedKol {
            background: rgba(105, 192, 255, 0.3);
          }

          .edit {
            cursor: pointer;

            i {
              color: #3a63f3;
            }
          }
        }

        .time-pick {
          display: inline-flex;
          align-items: center;
          min-width: 600px;
          justify-content: flex-end;

          .el-checkbox-group {
            .el-checkbox {
              margin-right: 12px;

              &.is-disabled.is-checked {
                .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
                  background-color: #3a63f3 !important;
                  border-color: #3a63f3 !important;

                  &::after {
                    border-color: white;
                  }
                }

                .el-checkbox__label {
                  color: #3a63f3;
                }
              }
            }
          }

          .data-pick {
            width: 120px;
          }
        }
      }

      .header-two {
        // max-width: 100%;
        display: flex;
        // padding: 0 24px 0 0;
        background-color: #fff;
        justify-content: space-between;
        margin: 16px 24px;
        box-shadow: 4px 6px 8px 0px rgba(6, 10, 50, 0.1);
        overflow-x: auto;

        .el-tabs {
          width: inherit;

          .el-tabs__header .el-tabs__item:last-child {
            margin-right: 40px;
          }

          .el-tabs__header {
            margin: 0 0 1px;
            padding-right: 2px;
            border: none;

            .el-tabs__item {
              border-radius: 4px;
              height: 44px;
              line-height: 44px;
              border: 0;

              &.is-active {
                background: #3a63f3;
                color: white;
                // box-shadow: 4px 6px 4px 0px
                // 	rgba(159, 77, 0, 0.2);
              }
            }

            .el-tabs__nav {
              border: 0;
            }
          }
        }

        .save {
          display: flex;
          align-items: center;
          color: #3a63f3;
          cursor: pointer;
        }
      }
    }

    .el-main {
      padding: 0;
      overflow: hidden auto;
      background-color: #f4f5fa;

      .roterView {
        //	background-color: white;
        background: #f4f5f7;
        width: calc(100% - 48px);
        margin-left: 24px;
        //min-height: calc(100vh - 300px);
        // box-shadow: 2px 2px 5px 0px rgba(159, 77, 0, 0.2);
        //	padding: 24px;
      }

      .views {
        min-height: calc(100vh - 180px);
        margin-bottom: 90px;
        //background-color: white;
      }

      .footer {
        // padding: 14px 20px !important;
        background-color: white;
        color: #7d8a9b;
        font-size: 12px;
        margin-top: 10px;
        width: 100%;

        p {
          text-align: center;
          margin-bottom: 0;
        }
      }
    }
  }
}
.content {
  width: 100%;
}
.bubble-download {
  margin-left: 0px;
  cursor: pointer;
  color: #2e54ed;
}
.bubble-share {
  margin-left: 0px;
  cursor: pointer;
  color: #2e54ed;
}
.bubble-feishu-share {
  margin-left: 0px;
  cursor: pointer;
  color: #2e54ed;
}
.bubble-container {
  height: calc(100vh - 100px);
  background: #f4f5fa;
  width: 100%;
  margin: 0 auto;
  overflow: hidden;
  position: relative;
}
/* 当 .headMsgBox 存在时 */
.headMsgBox + .content .bubble-container {
  height: calc(100vh - 140px);
}
.bubble-container .input-wrap {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 17px;
  font-family: inherit;
  color: #2c2c2c;
  background-color: #f4f5fa;
}
.bubble-container .stop-wrap-div {
  position: absolute;
  bottom: 170px;
  left: 50%;
  transform: translateX(-50%);
  right: 0;
  font-family: inherit;
  color: white;
  width: 120px;
}
.bubble-container .stop-wrap {
  border-radius: 5px;
  cursor: pointer;
  width: 100%;
  font-size: 16px;
  height: 40px;
  background-color: #7eb6ff;
  display: flex;
  justify-content: center;
  align-items: center;
}
.bubble-container .stop-wrap:hover {
  background-color: #7eb6ff95;
}
.bubble-container .input-wrap textarea {
  display: block;
  box-sizing: border-box;
  margin: 0 auto;
  width: 800px;
  // min-width: 80%;
  min-height: 48px;
  // max-width: calc(100% - 300px);
  max-height: 74px;
  font-family: inherit;
  color: #1d2043;
  background: white;
  font-size: 14px;
  letter-spacing: 0.5px;
  font-weight: 400;
  // margin: 10px 5%;
  border: none;
  padding: 13px 42px 13px 16px;
  outline: none;
  // box-shadow: 0 0 0 1px #d0d0d0 inset;
  resize: none;
  border-radius: 10px;
  box-shadow: none;
}
.home-input-area textarea {
  display: block;
  box-sizing: border-box;
  margin: 0 auto;
  width: 800px;
  // min-width: 80%;
  min-height: 48px;
  // max-width: calc(100% - 300px);
  max-height: 74px;
  font-family: inherit;
  color: #1d2043;
  background: white;
  font-size: 14px;
  letter-spacing: 0.5px;
  font-weight: 400;
  // margin: 10px 5%;
  border: none;
  padding: 13px 42px 13px 16px;
  outline: none;
  // box-shadow: 0 0 0 1px #d0d0d0 inset;
  resize: none;
  border-radius: 10px;
  box-shadow: none;
}
.bubble-content {
  white-space: pre-line;
  line-height: 24px;
  font-size: 16px;
}
p.bubble-content {
  margin: 0;
  width: 100%;
}
.input-send {
  position: absolute;
  right: 20px;
  bottom: 12px;
  font-size: 20px !important;
  cursor: pointer;
  color: #6182f5;
}
.chat-help {
  position: absolute;
  left: -10px;
  top: -10px;
  font-size: 20px !important;
  cursor: pointer;
  color: #6182f5;
}
.el-link {
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  vertical-align: middle;
  position: relative;
  text-decoration: none;
  outline: none;
  cursor: pointer;
  padding: 0;
  font-size: 14px;
  font-weight: 500;
}
.icon-help {
  position: absolute;
  top: 0;
  left: 0;
}

/* HTML: <div class="loader"></div> */
.loader {
  width: 7px;
  aspect-ratio: 1;
  border-radius: 50%;
  animation: l5 1s infinite linear alternate;
  display: inline-block;
  margin: 0 10px;
}
@keyframes l5 {
  0% {
    box-shadow: 10px 0 #000, -10px 0 #0002;
    background: #000;
  }
  33% {
    box-shadow: 10px 0 #000, -10px 0 #0002;
    background: #0002;
  }
  66% {
    box-shadow: 10px 0 #0002, -10px 0 #000;
    background: #0002;
  }
  100% {
    box-shadow: 10px 0 #0002, -10px 0 #000;
    background: #000;
  }
}

#countdown {
  font-size: 16px;
  font-weight: bold;
  text-align: center;
  margin: 0 10px;
}
#download-pop {
  position: absolute;
  border: 1px solid #ccc;
  background-color: #fff;
  border-radius: 4px;
  padding: 10px;
  display: none;
  background: #303133;
  color: #ffffff;
  margin-top: 20px;
  font-size: 12px;
}
#share-pop {
  position: absolute;
  border: 1px solid #ccc;
  background-color: #fff;
  border-radius: 4px;
  padding: 10px;
  display: none;
  background: #303133;
  color: #ffffff;
  margin-top: 20px;
  font-size: 12px;
}
#question-pop {
  position: absolute;
  border: 1px solid #ccc;
  background-color: #fff;
  border-radius: 4px;
  padding: 10px;
  display: none;
  background: #303133;
  color: #ffffff;
  margin-top: 20px;
  font-size: 12px;
}
#preview-window {
  display: none;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 999;
}

#preview-window img {
  position: absolute;
  max-width: 80%;
  max-height: 80%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

/* ******** 表格样式 **************** */
table {
  border-collapse: collapse;
  width: 100%;
  border: none;
}

th,
td {
  // border: 1px solid #ddd;
  border: none;
  padding: 10px 40px;
  text-align: left;
  letter-spacing: 1px;
}
th {
  font-weight: normal;
  font-size: 16px;
}

td a {
  text-decoration: none;
}

tr:nth-child(even) {
  background-color: #f7f7f7;
}

tr:hover {
  background-color: #f5f5f5;
}

@keyframes moveLeftRight {
  0%,
  100% {
    transform: translateX(0);
  }
  50% {
    transform: translateX(10px); /* 向右移动20px */
  }
}
.shouzhi-ani {
  animation: moveLeftRight 1.5s infinite alternate; /* 动画名称，持续时间，无限循环，交替运动 */
  color: #3a63f3;
  font-size: 28px !important;
  display: flex;
  justify-content: center;
  align-items: center;
}
/* ******** 表格样式 **************** */
</style>

<style lang="less" scoped>
.pop-table {
  margin-top: 10px;
  table {
    width: 100%;
    border-collapse: collapse;
  }
  th,
  td {
    border: 1px solid #dfe1e4;
    padding: 8px;
    text-align: left;
  }
  th {
    background-color: #f2f2f2;
    font-size: 14px;
  }
  tr:nth-child(even) {
    background-color: white;
  }
  .error {
    color: red;
  }
}
.headMsgBox {
  font-size: 13px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fcf8e3;
  border-color: #faebcc;
  color: #8a6d3b;
  width: 100%;
}
/* 移动端图片样式 */
.AI-mobile-content {
  text-align: center;
  position: relative;
  height: 100%;
  background-color: #2d58e6;
  .AI-image {
    max-width: 100%;
    height: 100%;
  }
}

@media screen and (max-width: 375px) {
  .AI-mobile-content {
    .AI-image {
      width: 90%;
      height: unset;
    }
  }
}
</style>
